import * as React from 'react';

export const ModalProgressBar: React.FC = () => {
  return (
    <>
      <div className="kpmf modal-progress-bar"></div>
    </>
  );
};
